// extracted by mini-css-extract-plugin
export default {"promoWrap":"E4NV-fg6KrDn6xMNtFX4Ag==","promo":"aKxWpB5ecoC1l0uI6+F4xw==","promoText":"HMq7sNTlhFTUEwKgFXRR4g=="};